import React from 'react';
import { DNABox, RichText, RichTextConfiguration } from '@alucio/lux-ui';

const EDITOR_CONFIGURATION: RichTextConfiguration = {
  formats: ['font', 'size', 'color', 'align', 'bold', 'italic', 'underline', 'header', 'list', 'indent', 'link'],
  modules: {
    toolbar: [
      [{ font: [false, 'Carlito', 'Lato', 'Oswald', 'Poppins', 'PT-Serif'] },
        { size: [false, '12px', '16px', '20px', '24px', '28px'] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'link', { color: [] }],
      [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }, { align: [] }],
    ],
  },
  defaultFont: 'Lato',
  defaultSize: '16px',
  preserveFormatting: true,
};
const READER_CONFIGURATION: RichTextConfiguration = {
  ...EDITOR_CONFIGURATION,
  modules: { toolbar: false },
};

type Props = Pick<React.ComponentProps<typeof RichText.Editor>,
  'value' | 'onChange' | 'editorHeight' | 'maxLength' | 'disabled'> & {
  readOnly?: boolean;
};

export const BulletinRichText: React.FC<Props> = ({ readOnly, ...props }) => readOnly ? (
  <DNABox appearance="col" style={{ marginHorizontal: -12, marginVertical: -8 }}>
    <RichText.Anchor configuration={READER_CONFIGURATION} value={props.value} />
  </DNABox>
) : (
  <RichText.Editor
    {...props}
    configuration={EDITOR_CONFIGURATION}
    accessibilityLabel="Post content"
  />
);
